import Helpers from '../Helpers'
import types from '../types'

/* eslint-disable quotes, max-len */
export const addLog = (log, time) => (dispatch, getState) => {
  // Updating the Modules
  try {
    const modules = getState()?.userReducer?.modules || {}
    // const modules = {}
    let moduleState = 'completed'
    let taskState = 'finished'
    const path = log.path.split('/')
    path.shift()
    if (path?.[2].includes('987987')) {
      path[2] = Helpers.resetTimeValue(path[2], time)
    }
    let newValue = structuredClone(log?.value)
    if (newValue?.time < time) {
      newValue.time = parseInt(time) + parseInt(newValue.time)
    }
    if (newValue?.type) { // regular logs only
      switch (newValue?.type) {
        case 'summary_output':
        case 'final_output':
          Helpers.setObjValueAtPath(modules, path[2], [path[0], 'last_completed_task'])
          break;
        case 'action_output':
          moduleState = 'running'
          taskState = 'running'
          break;
        case 'action':
          moduleState = 'running'
          taskState = 'running'
          break;
        default:
      }
      Helpers.setObjValueAtPath(modules, moduleState, [path[0], 'status'])
      Helpers.setObjValueAtPath(modules, taskState, [path[0], path[1], path[2], 'status'])
      if (newValue?.time !== undefined) {
        Helpers.setObjValueAtPath(modules, newValue?.time, [path[0], path[1], path[2], 'last_update'])
        Helpers.setObjValueAtPath(modules, newValue?.time, [path[0], 'last_completed'])
      }
    } else { // summary
      if (newValue?.description && newValue?.status) {
        newValue.status = 'thinking'
        Helpers.setObjValueAtPath(modules, 'thinking', [path[0], 'status'])
      }
      newValue = JSON.parse(Helpers.resetTimeValue(JSON.stringify(newValue), time))
    }
    Helpers.setObjValueAtPath(modules, newValue, path)
    const newModules = structuredClone(modules)
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        modules: newModules,
        summaries: newModules?.['core']?.['summaries'],
      },
    })
  } catch (e) {
    console.log(e)
  }
}
